module.exports = __webpack_public_path__ + "img/favicons/cha/apple-touch-icon.png";